import { Card, Row, Select, Space, Tag } from "antd";
import { Content } from "antd/lib/layout/layout";
import { Steps, Button } from "antd";
import { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { ProductoVariante } from "./ProductoVariante";
import { ProductSimple } from "./ProductSimple";
import {
  GetAllAttributes,
  GetAllCategorys,
  GetAllTermsAttributes,
  baseurl,
  baseurlwc,
  credentials,
} from "../../api/api";
import { GetTokenProducto } from "../../api/utils";
import { ReviewProduct } from "./ReviewProduct";
import axios from "axios";
import Cookies from "js-cookie";
import { Atributes, useAttributesStore } from "./Atributes";
import { toast } from "react-toastify";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { create } from "zustand";

const { Step } = Steps;
const { Option } = Select;

const defProductConfig = {
  TipoProducto: 1,
  IdIva: 0,
  webCategoryIds: [],
  ParametrizacionContableProducto: [
    { NumeroCuenta: "14351501", Tipo: 0 }, // Inventario
    { NumeroCuenta: "41351501", Tipo: 1 }, // Ventas
    { NumeroCuenta: "61351501", Tipo: 2 }, // Costo de Ventas
    { NumeroCuenta: "41750501", Tipo: 4 }, // Devolución Compras
    { NumeroCuenta: "62259501", Tipo: 5 }, // Devolución Ventas
  ],
};

export const TYPE_PRODUCT = "Producto";

export const useProductStore = create((set) => ({
  type: TYPE_PRODUCT,
  isProduct: true,
  categorys: [],
  data: defProductConfig,
  setType: () =>
    set({ type: TYPE_PRODUCT, isProduct: true, data: defProductConfig }),
  setData: (data) => set((state) => ({ data: { ...state.data, ...data } })),
  setcategorys: (categorys) => set({ categorys }),
  setCategory: (index, code) =>
    set((state) => {
      const data = Object.assign({}, state.data);
      data.ParametrizacionContableProducto[index].NumeroCuenta = code;
      return { data };
    }),
  reset: () => set({ data: defProductConfig }),
  knowName: (id, categorys) => {
    let name = categorys.filter((category) => category.id === id);
    return name[0]?.name || "";
  },
}));

export const LayoutProducto = () => {
  const producto = useProductStore();
 const attributes = useAttributesStore();

const brands = Array.isArray(attributes?.data?.[1])
  ? attributes.data[1]
  : [];


  const reloadAttributes = async () => {
    toast.info("Actualizando marcas...");

    try {
      const res = await GetAllAttributes();

      const formattedList = res.data.map((attr) => ({
        id: attr.id,
        name: attr.name,
      }));

      attributes.setList(formattedList);

      const results = await Promise.all(
        formattedList.map((item) =>
          GetAllTermsAttributes(item.id)
            .then((res) => ({ id: item.id, terms: res.data || [] }))
            .catch((err) => {
              console.error("Error cargando términos:", err);
              return { id: item.id, terms: [] };
            })
        )
      );

      const groups = results.reduce((acc, { id, terms }) => {
        acc[id] = terms;
        return acc;
      }, {});

      attributes.setGroups(groups);

      toast.success("Marcas actualizadas correctamente");
    } catch (err) {
      console.error("reloadAttributes error:", err);
      toast.error("Error al actualizar marcas");
    }
  };

  useEffect(() => {
    GetAllAttributes().then((res) => {
      const formattedList = res.data.map((attr) => ({
        id: attr.id,
        name: attr.name,
      }));
      attributes.setList(formattedList || []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (attributes.list.length > 0) {
      Promise.all(
        attributes.list.map((item) =>
          GetAllTermsAttributes(item.id)
            .then((res) => ({ id: item.id, terms: res.data || [] }))
            .catch((err) => {
              toast.error(
                `Error al cargar términos de ${item.name}: ${err.message}`
              );
              return { id: item.id, terms: [] };
            })
        )
      ).then((results) => {
        const groups = results.reduce((acc, { id, terms }) => {
          acc[id] = terms;
          return acc;
        }, {});
        attributes.setGroups(groups);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes.list]);

  const [current, setCurrent] = useState(0);
  const [selected, setselected] = useState(null);
  const [controlStatusGeneral, setcontrolStatusGeneral] = useState({
    nextDisabled: true,
    loading: false,
  });

  const resetReviewStatus = {
    nextDisabled: true,
    loading: false,
    finish: false,
    step: 0,
    status: undefined,
    messagestep1: "",
    messagestep2: "",
    messagestep3: "",
  };

  const buildWebCategories = (productData) => {
    const categoryIds = [
      productData?.IdCategoria,
      productData?.IdSubCategoria,
      ...(Array.isArray(productData?.webCategoryIds)
        ? productData.webCategoryIds
        : []),
    ]
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id) && id > 0);

    return Array.from(new Set(categoryIds)).map((id) => ({ id }));
  };

  const createVariableParentWebProduct = (productstore) => {
    if (!producto.isProduct) {
      toast.error("Solo se pueden crear productos, no servicios.");
      return;
    }

    const productotosave = {
      ...producto.data,
      ...productstore,
    };

    setcontrolStatusGeneral((prev) => ({
      ...prev,
      messagestep1: "Preparando producto padre para la página web...",
      messagestep2: "Esperando creación en Página Web...",
      messagestep3: "",
      loading: true,
      step: 1,
      status: "loading",
    }));

    const brandName =
      brands.length && productotosave.IdMarca
        ? brands.find((b) => b.id === productotosave.IdMarca)?.name
        : null;

    const parentAttributes = [];

    if (brandName && brandName.trim() !== "") {
      parentAttributes.push({
        id: 1,
        variation: false,
        visible: true,
        options: [brandName],
      });
    }

    const producttowc = {
      name: productotosave.Descripcion,
      meta_data: [
        {
          key: "referencia",
          value: productotosave.Codigo,
        },
      ],
      type: "variable",
      status: "pending",
      tags: (producto.data.tags || []).map((tag) => ({ name: tag })),
      categories: buildWebCategories(productotosave),
      ...(parentAttributes.length && { attributes: parentAttributes }),
    };

    setcontrolStatusGeneral((prev) => ({
      ...prev,
      messagestep1: "Producto padre listo para enviarse a la página web",
      messagestep2: "Creando producto padre en Página Web...",
      loading: true,
      step: 2,
      status: "loading",
    }));

    axios
      .post(baseurlwc + `/products?${credentials}`, { ...producttowc })
      .then((res) => {
        if (res.data.id) {
          Cookies.set("productid", res.data.id);
          Cookies.set("productname", res.data.name);
          setcontrolStatusGeneral((prev) => ({
            ...prev,
            messagestep2: "Producto padre de Página Web creado correctamente",
            step: 3,
            status: "success",
            finish: true,
            loading: false,
          }));
        }
      })
      .catch(() => {
        setcontrolStatusGeneral((prev) => ({
          ...prev,
          messagestep2: "No se pudo crear el producto padre en Página Web.",
          step: 2,
          status: "error",
          loading: false,
        }));
      });

    setCurrent((prev) => prev + 1);
  };

  const addProductSimple = (productstore) => {
    if (!producto.isProduct) {
      toast.error("Solo se pueden crear productos, no servicios.");
      return;
    }

    console.log("@@productstore", productstore);

    if (selected === "2") {
      createVariableParentWebProduct(productstore);
      return;
    }

    const getToken = GetTokenProducto(producto.data);
    setcontrolStatusGeneral({
      ...controlStatusGeneral,
      messagestep1: "Obteniendo token...",
      messagestep2: "Esperando respuesta...",
      loading: true,
      step: 1,
    });

    getToken.then((token) => {
      setcontrolStatusGeneral({
        ...controlStatusGeneral,
        messagestep1: "Token obtenido correctamente",
        messagestep2: "Creando producto...",
        loading: true,
        step: 2,
        status: "loading",
      });

      let { data } = token;
      if (data) {
        console.log("@@data", data);
        console.log("@@product", producto.data);

        let productotosave = {
          ...producto.data,
          Token: data,
          Talla: [
            {
              Talla: "00",
              Existencia: 0,
              PrecioVenta: producto.data.PrecioVentaConIva1,
              Token: data,
              NumeroFactura: "",
              CodigoBarras: "",
              NumRecibo: "",
              CUFE: "",
              IdOrdenPedidoCliente: 0,
              IdNotaCreditoElectronica: 0,
              Exito: true,
              MensajeError: "",
              Pila: "",
            },
          ],
        };

          axios
            .post(baseurl + "GuardarProductoTallasConContabilidad", {
              ...productotosave,
            })
            .then((res) => {
              setcontrolStatusGeneral({
                ...controlStatusGeneral,
                messagestep1: "Token obtenido correctamente",
                messagestep2: res.data.MensajeError,
                loading: true,
                step: res.data.Exito ? 3 : 2,
                status: res.data.Exito ? "success" : "error",
              });

              if (res.data.Exito) {
                setcontrolStatusGeneral({
                  ...controlStatusGeneral,
                  messagestep3: "Creando producto en Página Web...",
                  loading: true,
                  step: 3,
                  status: "loading",
                });

                // Obtener nombre de marca si existe
                const brandName =
                  brands.length && productotosave.IdMarca
                    ? brands.find((b) => b.id === productotosave.IdMarca)?.name
                    : null;

                // Construir attributes SOLO si hay término
                const attributes = [];

                if (brandName && brandName.trim() !== "") {
                  attributes.push({
                    id: 1,
                    variation: false,
                    visible: true,
                    options: [brandName],
                  });
                }

                let producttowc = {
                  name: productotosave.Descripcion,
                  meta_data: [
                    {
                      key: "referencia",
                      value: productotosave.Codigo,
                    },
                  ],
                  sku: res.data.ListadoCodigoBarrasTalla[0].CodigoBarrasTalla,
                  type: "simple",
                  regular_price: `${productotosave.PrecioVentaConIva1}`,
                  manage_stock: true,
                  contable_codes:
                    productotosave.ParametrizacionContableProducto,
                  status: "pending",
                  sale_price: `${productotosave.PrecioVentaConIva1}`,
                  stock_quantity: 0,
                  weight: productotosave.weight,
                  dimensions: {
                    length: producto.data.dimensions.length,
                    width: producto.data.dimensions.width,
                    height: producto.data.dimensions.height,
                  },
                  stock_status: "outofstock",
                  categories: buildWebCategories(productotosave),
                  tags: (producto.data.tags || []).map((tag) => ({
                    name: tag,
                  })),
                };

                axios
                  .post(baseurlwc + `/products?${credentials}`, {
                    ...producttowc,
                  })
                  .then((res) => {
                    if (res.data.id) {
                      Cookies.set("productid", res.data.id);
                      Cookies.set("productname", res.data.name);
                      setcontrolStatusGeneral({
                        ...controlStatusGeneral,
                        messagestep3:
                          "Producto de Página Web creado correctamente",
                        step: 4,
                        status: "success",
                        finish: true,
                        loading: false,
                      });
                    }
                  });
              } else {
                toast.error(res.data.MensajeError);
              }
              });
        }
      });

      setCurrent(current + 1);
  };

  useEffect(() => {
    GetAllCategorys().then((res) => {
      console.log("@@categories", res.data);
      producto.setcategorys(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
    setcontrolStatusGeneral({
      ...controlStatusGeneral,
      loading: false,
    });
  };

  const renderStepsVariant = () => {
    return stepsProductVariant.map((item) => (
      <Step key={item.title} title={item.title} />
    ));
  };

  const renderSteps = () => {
    return steps.map((item) => <Step key={item.title} title={item.title} />);
  };

  const handleselectproductype = (typroduct) => {
    setselected(typroduct);
    producto.setType();
  };

  let rulesShowButtonNext = (selectedP, currentP = 1) => {
    let btnnext = false;
    let btnfinish = false;
    let btnprev = false;
    if (selectedP === "1") {
      switch (currentP) {
        case 0:
          btnnext = true;
          break;
        case 1:
          btnprev = true;
          break;
        case 2:
          btnfinish = true;
          btnprev = true;
          break;
        default:
        //
      }
    } else if (selectedP === "2") {
      switch (currentP) {
        case 0:
          btnnext = true;
          break;
        case 1:
          btnprev = true;
          break;
        case 2:
          btnnext = true;
          btnprev = true;
          break;
        case 4:
          btnfinish = true;
          break;
        default:
        //
      }
    }

    return {
      btnnext,
      btnfinish,
      btnprev,
    };
  };

  let steps = [
    {
      title: "Tipo Producto",
      content: (
        <TipoDeProducto
          handleselectproductype={handleselectproductype}
          selected={selected}
          setcontrolStatusGeneral={setcontrolStatusGeneral}
        />
      ),
    },
    {
      title: "Crear Producto",
      content: (
        <RenderTypeProduct
          selected={selected}
          addProductSimple={addProductSimple}
          reloadAttributes={reloadAttributes}
        />
      ),
    },
    {
      title: "Resumen",
        content: (
          <ReviewProduct
            controlStatusGeneral={controlStatusGeneral}
            productFlow="simple"
          />
        ),
    },
  ];

  let stepsProductVariant = [
    {
      title: "Tipo",
      content: (
        <TipoDeProducto
          handleselectproductype={handleselectproductype}
          selected={selected}
          setcontrolStatusGeneral={setcontrolStatusGeneral}
        />
      ),
    },
    {
      title: "Detalles",
      content: (
        <RenderTypeProduct
          selected={selected}
          addProductSimple={addProductSimple}
          reloadAttributes={reloadAttributes}
        />
      ),
    },
    {
      title: "Resumen",
        content: (
          <ReviewProduct
            controlStatusGeneral={controlStatusGeneral}
            productFlow="variable-parent-web"
          />
        ),
    },
    {
      title: "Atributos",
      content: (
        <Atributes
          controlStatusGeneral={controlStatusGeneral}
          next={next}
          setcontrolStatusGeneral={setcontrolStatusGeneral}
        />
      ),
    },
    {
      title: "Variantes",
      content: (
        <ProductoVariante
          addProductSimple={addProductSimple}
          variation
          reloadAttributes={reloadAttributes}
        />
      ),
    },
  ];

  return (
    <Content className="product-dashboard-content">
      <Row justify="center">
        <Card
          className="product-dashboard-card"
          title={
            !selected
              ? "Crear Producto"
              : selected === "1"
              ? "Gestión Producto Simple"
              : "Gestión Producto Variable"
          }
        >
          <Steps current={current} className="product-dashboard-steps">
            {selected === "2" ? renderStepsVariant() : renderSteps()}
          </Steps>
          <div className="product-dashboard-body steps-content">
            {selected === "1"
              ? steps[current].content
              : stepsProductVariant[current].content}
          </div>
          <div className="product-dashboard-actions steps-action">
            {rulesShowButtonNext(selected, current).btnfinish && (
              <Button
                icon={<CheckOutlined />}
                disabled={controlStatusGeneral.loading}
                className="product-dashboard-button product-dashboard-button-primary product-dashboard-button-end"
                type="primary"
                onClick={() => {
                  setCurrent(0);
                  setselected(null);
                    setcontrolStatusGeneral(resetReviewStatus);
                  Cookies.remove("productid");
                  Cookies.remove("productname");
                  producto.reset();
                  attributes.reset();
                }}
              >
                Finalizar
              </Button>
            )}

            {rulesShowButtonNext(selected, current).btnprev && (
              <Button
                icon={<ArrowLeftOutlined />}
                className="product-dashboard-button"
                onClick={() => prev()}
              >
                Regresar
              </Button>
            )}

            {rulesShowButtonNext(selected, current).btnnext && (
              <Button
                icon={<ArrowRightOutlined />}
                disabled={controlStatusGeneral.loading}
                className="product-dashboard-button product-dashboard-button-primary"
                type="primary"
                style={{ display: current === 4 ? "none" : "inline-flex" }}
                onClick={() => next()}
              >
                Siguiente
              </Button>
            )}
          </div>
        </Card>
      </Row>
    </Content>
  );
};

const TipoDeProducto = (props) => {
  return (
    <div className="product-type-panel">
      {props.selected === null && (
        <Row justify="center" className="product-type-empty">
          <Space direction="vertical" align="center" size="middle">
            <Text className="product-type-title">
              Selecciona el tipo de producto a crear
            </Text>
            <img
              src="https://cdn3d.iconscout.com/3d/premium/thumb/product-5806313-4863042.png"
              alt=""
              className="product-type-illustration"
            />
            <Select
              placeholder="Selecciona tipo de producto"
              onChange={(value) => {
                props.handleselectproductype(value);
                props.setcontrolStatusGeneral({
                  nextDisabled: false,
                });
              }}
              className="product-type-select"
            >
              <Option style={{ fontSize: "19px" }} value="1">
                Producto simple
              </Option>
              <Option style={{ fontSize: "19px" }} value="2">
                Producto variable
              </Option>
            </Select>
          </Space>
        </Row>
      )}

      <Row
        justify="center"
        className="product-type-selected-row"
      >
        {props.selected != null && (
          <Space
            direction="vertical"
            align="center"
            className="product-type-selected"
          >
            <Text className="product-type-title">
              Tipo de producto a crear
            </Text>
            <img
              src="https://cdn3d.iconscout.com/3d/premium/thumb/product-5806313-4863042.png"
              alt="Producto"
              className="product-type-illustration product-type-illustration-small"
            />
            <Tag
              closable
              onClose={() => {
                props.handleselectproductype(null);
                props.setcontrolStatusGeneral({
                  nextDisabled: true,
                });
              }}
              className="product-type-tag"
            >
              {props.selected === "1" ? "Producto Simple" : "Producto Variable"}
            </Tag>
          </Space>
        )}
      </Row>
    </div>
  );
};

const RenderTypeProduct = ({
  selected,
  addProductSimple,
  reloadAttributes,
}) => {
  return selected === "1" ? (
    <ProductSimple
      addProductSimple={addProductSimple}
      reloadAttributes={reloadAttributes}
    />
  ) : (
    <ProductoVariante
      addProductSimple={addProductSimple}
      reloadAttributes={reloadAttributes}
    />
  );
};
